<template>
    <div class="width100">

        <b-modal id="modalPhoto" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>

            </template>
            <div class="d-block">
                <p v-html="image"></p>
                <div class="row">
                    <div class="col-12 text-center">

                    </div>
                </div>
            </div>
        </b-modal>

        <Aide v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
              v-bind:user="user" v-bind:idAide="5"></Aide>

        <h3 class="titreSolu text-center">Statistiques</h3>
        <h3 class="titreSolu text-center" v-if="niveau==1">De quelle machine il s'agit ?</h3>
        <div v-if="niveau == 1" class="row" style="overflow: scroll;height:250px;">
            <div v-for="(machine, keyMachine) in listMachine" :key="keyMachine" class="colSolu col-md-12 col-lg-4">
                <div class="thtab userList col-12 text-center rounded"
                     @click="choixMachine(keyMachine)">
                    {{machine.nom}}
                </div>
            </div>
        </div>
        <div v-if="niveau >= 2" class="row">
            <div class="col-12 text-center">
                <h3>{{machine.nom}}</h3>
            </div>
        </div>
        <h3 class="titreSolu text-center" v-if="niveau==2">Quelle période ?</h3>
        <div v-if="niveau == 2">
            <div class="row">
                <div class="col-6 text-center">
                    <input type="date" v-model="dateDeb" class="form-control"/>
                </div>
                <div class="col-6 text-center">
                    <input type="date" v-model="dateFin" class="form-control"/>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col-12 text-center">
                    <button class="btn btn-primary" block @click="getStat()">Valider</button>
                    &nbsp;
                    <button class="btn btn-danger" block @click="returnNiveau()">Retour</button>
                </div>
            </div>
        </div>
        <br />

        <div v-if="niveau == 2 && listStat.length">
            <div class="row">
                <table class="table table-striped table-bordered ">
                    <tr>
                        <th class="thtab">Date</th>
                        <th class="thtab">Action</th>
                        <th class="thtab">Employé</th>
                        <th class="thtab">Défaut</th>
                        <th class="thtab">Durée</th>
                        <th class="thtab">Niveau charge</th>
                        <th class="thtab">Horamètre</th>
                    </tr>
                    <tr v-for="(stat, key) in listStat" :key="key">
                        <td>{{stat.date}}</td>
                        <td>{{stat.action}}
                            <i v-if='stat.photo_operation == 1' class="fa-solid fa-image text-right text-primary" @click="affichePhoto(stat.id,'operation',0)"></i>
                            <i v-if='stat.photo_panne_reparation == 1' class="fa-solid fa-image text-right text-primary" @click="affichePhoto(stat.idPanne,'panneReparation',0)"></i>
                        </td>
                        <td>{{stat.user}}</td>
                        <td>{{stat.defaut}}
                            <span v-for="(photoP, key) in stat.photo_panne_declaration" :key="key">
                                <i v-if='photoP == 1' class="fa-solid fa-image text-right text-primary" @click="affichePhoto(stat.idPanne,'panneDeclaration',key)"></i>
                            </span>
                        </td>
                        <td>{{stat.duree}}</td>
                        <td>{{stat.niveauCharge}}</td>
                        <td>{{stat.horametre}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import Aide from './Aide';

    export default {
        name: "Statistique",
        props: ['token', 'site', 'user', 'racine', 'userId','idUser','systemeClient'],
        data() {
            return {
                listMachine:[],niveau:1,machine:null,dateDeb:null,dateFin:null,
                listStat:[],image:null,
            };
        },
        methods:
        {
            tokenValide(json) {
                if (json['status'] == '401') {
                    this.$emit('token')
                }
            },
            getMachines()
            {
                fetch(this.racine + this.site + 'api/machines?systemeClient='+this.systemeClient+'&order[nom]=asc'+"&actif=1", {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listMachine = json['hydra:member']
                        }
                    })
                })
            },
            choixMachine(key)
            {
                this.machine = this.listMachine[key]
                this.niveau = 2
                this.listStat = []

            },
            returnNiveau() {
                if (this.niveau > 1) {
                    this.niveau--
                }
            },
            getStat()
            {
                fetch(this.racine + this.site + 'api/get_stat/'+this.machine.id+'/'+this.dateDeb+'/'+this.dateFin, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listStat = json['listEvent']
                        }
                    })
                })
            },
            affichePhoto(statId,type,key)
            {
                console.log(statId)
                console.log(type)
                fetch(this.racine + this.site + 'api/get_photo_stat/'+statId+'/'+type+'/'+key, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.image = json['img']
                            this.$bvModal.show('modalPhoto')
                        }
                    })
                })
            }
        },
        mounted() {
            this.getMachines()
            var today = new Date()
            today.setMonth(today.getMonth() - 12);
            this.dateFin = new Date().toISOString().substr(0, 10)
            this.dateDeb = today.toISOString().substr(0, 10)
        },
        components: {
            Aide,
        }
    }
</script>

<style scoped>

</style>